"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.PropertyRoomTypeUpdateDto = void 0;
var class_transformer_1 = require("class-transformer");
var class_validator_1 = require("class-validator");
var bed_config_dto_1 = require("./property-room-type-deps/bed-config.dto");
var extra_bed_dto_1 = require("./property-room-type-deps/extra-bed.dto");
var name_parts_dto_1 = require("./property-room-type-deps/name-parts.dto");
var occupancy_dto_1 = require("./property-room-type-deps/occupancy.dto");
var room_type_amenities_dto_1 = require("./property-room-type-deps/room-type-amenities.dto");
var PropertyRoomTypeUpdateDto = (function () {
    function PropertyRoomTypeUpdateDto() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['SINGLE', 'MULTIPLE']),
        __metadata("design:type", String)
    ], PropertyRoomTypeUpdateDto.prototype, "layout");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsNotEmpty(),
        __metadata("design:type", Object)
    ], PropertyRoomTypeUpdateDto.prototype, "type");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", Object)
    ], PropertyRoomTypeUpdateDto.prototype, "class");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", Object)
    ], PropertyRoomTypeUpdateDto.prototype, "view");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], PropertyRoomTypeUpdateDto.prototype, "label");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], PropertyRoomTypeUpdateDto.prototype, "privateUse");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", Object)
    ], PropertyRoomTypeUpdateDto.prototype, "featuredAmenity");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", Object)
    ], PropertyRoomTypeUpdateDto.prototype, "areaType");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PropertyRoomTypeUpdateDto.prototype, "numberOfBedrooms");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNotEmpty(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['SMOKING', 'NO_SMOKING', 'IN_SOME_ROOMS']),
        __metadata("design:type", String)
    ], PropertyRoomTypeUpdateDto.prototype, "smokingPreference");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], PropertyRoomTypeUpdateDto.prototype, "wheelchairAccess");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return name_parts_dto_1.NamePartsDto; }),
        class_validator_1.ValidateNested(),
        __metadata("design:type", name_parts_dto_1.NamePartsDto)
    ], PropertyRoomTypeUpdateDto.prototype, "nameParts");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsArray({ each: true }),
        class_transformer_1.Type(function () { return bed_config_dto_1.BedConfigDto; }, {}),
        class_validator_1.ValidateNested({ each: true }),
        __metadata("design:type", Array)
    ], PropertyRoomTypeUpdateDto.prototype, "bedConfigs");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return extra_bed_dto_1.ExtraBedDto; }),
        class_validator_1.ValidateNested(),
        __metadata("design:type", extra_bed_dto_1.ExtraBedDto)
    ], PropertyRoomTypeUpdateDto.prototype, "extraBed");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return occupancy_dto_1.OccupancyDto; }),
        class_validator_1.ValidateNested(),
        __metadata("design:type", occupancy_dto_1.OccupancyDto)
    ], PropertyRoomTypeUpdateDto.prototype, "occupancy");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return room_type_amenities_dto_1.RoomTypeAmenitiesDto; }),
        class_validator_1.ValidateNested(),
        __metadata("design:type", room_type_amenities_dto_1.RoomTypeAmenitiesDto)
    ], PropertyRoomTypeUpdateDto.prototype, "amenities");
    return PropertyRoomTypeUpdateDto;
}());
exports.PropertyRoomTypeUpdateDto = PropertyRoomTypeUpdateDto;
//# sourceMappingURL=property-room-type-update.dto.js.map